<template>
  <div class="card-n" :class="{ confirm: confirm }">
    <div class="title">
      {{ $t("user.mine.tranerOut") }}
    </div>
    <!-- 转出地址 -->
    <div class="form-group">
      <span class="form-label trans-add required">
        {{ $t("home.components.transOut.myadd") }}:
      </span>
      <input
        class="input-text"
        v-if="!confirm"
        disabled
        :value="wallets.address"
        :placeholder="$t('home.components.transOut.inputadd')"
      />
      <p v-else class="textVal">
        {{ wallets.address }}
      </p>
    </div>
    <!-- 目的地址 -->
    <div class="form-group">
      <span class="form-label trans-add required">
        {{ $t("home.components.transOut.targetAdd") }}:
      </span>
      <input
        class="input-text"
        v-model="form.address"
        v-if="!confirm"
        :disabled="confirm"
        @blur="feeBlur"
        :placeholder="$t('home.components.transOut.inputadd')"
      />
      <p v-else class="textVal">
        {{ form.address }}
      </p>
    </div>
    <!-- 金额 -->
    <div class="form-group amount-group">
      <span class="subtitle form-label required">
        {{ $t("home.components.transOut.num") }}:
      </span>
      <div class="input-group">
        <input
          class="input-text"
          v-model="form.amount"
          :disabled="confirm"
          @blur="feeBlur"
          :placeholder="$t('home.components.transOut.inputnum')"
        />
        <span class="suffix">MASS</span>
      </div>
      <span class="all-trans" @click="form.amount = balance.available">{{
        $t("home.components.transOut.all")
      }}</span>
    </div>
    <!-- 手续费 、 当前余额 -->
    <div class="form-group cost">
      <span class="form-label required">
        {{ $t("home.components.transOut.fee") }}
      </span>
      <span class="num">{{ fee }} </span>&nbsp;MASS
      <div class="right d-xs-none">
        {{ $t("home.components.transOut.balance")
        }}<span class="num">{{ balance.available }} </span> MASS
      </div>
    </div>
    <div class="form-group cost d-xs-block d-none" v-if="!confirm">
      <span class="form-label ">
        {{ $t("home.components.transOut.balance") }}
      </span>
      <span class="num">{{ balance.available }} </span>&nbsp;MASS
    </div>

    <p class="tips">{{ $t("home.components.transOut.tip") }}</p>
    <div style="text-align: right;">
      <button
        v-if="!confirm"
        class="btn btn-blue-sm"
        v-loading="loading"
        @click="toConfrim"
      >
        {{ $t("home.components.transOut.btn") }}
      </button>
      <button v-else class="btn btn-blue-sm" @click="showPassword">
        {{ $t("home.components.transOut.send") }}
      </button>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      form: {
        address: "",
        amount: "",
      },
      fee: 0,
      loading: false,
      passphrase: "",
      pwdType: "password",
      errmsg: "",
      confirm: false,
    };
  },
  computed: {
    ...mapState("wallet", ["balance", "wallets"]),
  },
  methods: {
    ...mapActions("wallet", [
      "getBalance",
      "getFee",
      "sendTransaction",
      "refrushWallet",
    ]),
    async feeBlur() {
      try {
        this.getfeeVaild();
        await this.getFeeMethod();
      } catch (e) {
        this.errmsg = e;
      }
    },
    getfeeVaild() {
      const { address, amount } = this.form;
      if (!address) {
        throw this.$t("home.components.transOut.input-add");
      }
      if (!amount) {
        throw this.$t("home.components.transOut.input-amount");
      }
      if (isNaN(amount)) {
        throw this.$t("home.components.transOut.input-amount");
      }
      if (Number(amount) > Number(this.balance.available)) {
        throw this.$t("home.components.transOut.noleft");
      }
    },
    async getFeeMethod() {
      try {
        this.loading = true;
        const res = await this.getFee({ outputs: [this.form] });
        this.fee = res.fee;
      } catch (e) {
        this.fee = 0;
      }
      this.loading = false;
    },
    async vaild() {
      const { fee } = this;
      try {
        this.getfeeVaild();
        if (!fee) {
          await this.getFeeMethod();
        }
        return !!this.fee;
      } catch (e) {
        this.$tooltip.warning(e);
        return false;
      }
    },
    showPassword() {
      this.$emit("showPassword", {
        outputs: [this.form],
        fee: this.fee,
      });
    },
    async toConfrim() {
      if (await this.vaild()) {
        this.confirm = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.confirm {
  .input-text {
    border: none !important;
  }
  .suffix {
    background: transparent !important;
    border: none !important;
  }
  .amount-group {
    .input-group {
      flex: inherit;
    }
  }
  .all-trans,
  .cost .right,
  .required::before,
  .tips {
    display: none;
  }
}
.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .form-label {
    width: 70px;
    flex-shrink: 0;
    text-align: right;
    margin-right: 20px;
    &.required::before {
      content: "*";
      color: var(--main-color);
    }
  }
  .textVal {
    word-break: break-all;
  }
  .input-text {
    flex: 1;
    background: #ffffff;
    border-radius: 2px;
    border: 1px solid #d9d8d8;
    padding: 8px 10px;
    font-size: 12px;
    font-weight: 400;
    color: #060606;
    line-height: 17px;
  }
  .all-trans {
    font-size: 12px;
    font-weight: 400;
    color: #e73419;
    line-height: 17px;
    margin-left: 10px;
  }
  .input-group {
    flex: 1;
    display: flex;
    input {
      border-radius: 2px 0px 0px 2px;
      border-right: none;
      outline: none;
      -webkit-appearance: none;
    }
    .suffix {
      background: rgba(217, 216, 216, 0.5);
      border-radius: 0px 2px 2px 0px;
      opacity: 0.5;
      line-height: 35px;
      border: 1px solid #d9d8d8;
      border-left: none;
      font-size: 12px;
      font-weight: 400;
      color: #060606;
      padding: 0 15px;
    }
  }
}
.cost {
  .num {
    font-size: 12px;
    font-weight: bold;
    color: #e73419;
    line-height: 12px;
  }
  .right {
    margin-left: 100px;
  }
}
@media screen and (max-width: 768px) {
  .btn-blue-sm {
    margin: 50px 0 20px;
  }
  .form-group {
    align-items: baseline;
  }
}
</style>
<style lang="sass" scoped>
.card-n
  padding: 2rem
  width: 56rem;
  background: url('~@/assets/image/modal_sm.png') no-repeat
  background-size: 100% 100%
  .title
    width: 100%
    border-bottom: 0.1rem solid rgba(222,222,222,0.4)
    padding-bottom: 2rem
    color: #333333
    font-size: 1.6rem
    font-weight: bold
    margin-bottom: 2.9rem
    position: relative
    .logo
      width: 3.5rem
    .text
      position: absolute
      top: 1rem
      left: 4.5rem
  .trans-add
    font-size: 1.2rem
    font-weight: bold
    color: #333333
    position: relative
    .scan
      position: absolute
      right: 0
  .subtitle
    font-size: 1.2rem
    font-weight: bold
    color: #333333
    position: relative

  .verify
    width: 100%
    padding: 0.9rem 0
    font-size: 1.6rem
    font-weight: 400
    border: none
    border-bottom: 0.05rem solid #dedede
    color: rgba(51,51,51,1)
    outline: none
  .trans-num
    width: 100%
    padding: 0.9rem 0
    font-size: 1.6rem
    font-weight: 400
    border: none
    border-bottom: 0.05rem solid #dedede
    color: rgba(51,51,51,1)
    outline: none
  input::-webkit-input-placeholder
    color: rgba(51,51,51,0.1)
  input:-moz-placeholder
    color: rgba(51,51,51,0.1)
  input::-moz-placeholder
    color: rgba(51,51,51,0.1)
  input:-ms-input-placeholder
    color: rgba(51,51,51,0.1)


  .tips
    font-size: 1.2rem
    font-weight: 400
    color: #D0021B
    line-height: 2.4rem
  .blue-btn
    outline: none
    width: 100%
    height: 4.9rem
    background: #DC472A
    border-radius: 0.4rem
    border: none
    color: #ffffff
    margin: 3.2rem 0 0 0
</style>
